import VehicleFilterToggle from './VehicleFilterToggle';

export default VehicleFilterToggle;
